import './index.css';

import React from 'react';
import ReactDOM from 'react-dom';

import Playground from './components/Playground/Playground';
import * as serviceWorker from './serviceWorker';

const GREEN_COLOR = '#00bb00';
const RED_COLOR = '#e80606';

const TEXTS = [
  'You are my idol!',
  `I'm not trash talking, I'm talking to trash`,
  'Great Job! I have never seen such a bad article',
  'Your birth certificate is an apology from the condom factory.',
  'What you lack in brain cells, you make up for in chromosome count.',
];
const STATUSES = [
  'Good',
  'Insult',
  'Attack on author',
  'Insult',
  'Rejected',
];
const COLORS = [GREEN_COLOR, RED_COLOR, RED_COLOR, RED_COLOR, RED_COLOR];

function App() {
  const [index, setIndex] = React.useState(0);

  const increment = React.useCallback(
    () => setTimeout(
      () => {
        let memIndex = index + 1;
        if (memIndex >= TEXTS.length) { memIndex = 0; }
        setIndex(-1)
        setTimeout(() => setIndex(memIndex), 10);
      },
      4000,
    ),
    [index]);

  return (
    <Playground increment={increment} text={TEXTS[index]} status={STATUSES[index]} color={COLORS[index]} />
  )
}

ReactDOM.render(
  <App />,
  document.getElementById('mments-playground')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
